import { defineMessages } from 'react-intl'

const messages = defineMessages({
    firstName: 'Nombre',
    firstNamePlaceholder: 'Introduce el nombre',
    lastName: 'Apellidos',
    lastNamePlaceholder: 'Introduce los apellidos',
    fly: 'Nº de vuelo (Opcional)',
    flyPlaceholder: 'Introduce el número de vuelo',
    train: 'Nº de billete de tren (Opcional)',
    trainPlaceholder: 'Introduce el número de billete de tren',
    checked: 'Obligatorio',
    email: 'Correo electrónico del conductor principal (Opcional)',
    emailPlaceholder: 'Introduce  el correo electrónico',
    phonePlaceholder: 'Nº de teléfono',
    date: 'Fecha de nacimiento',
    invalidCharacters: 'Hay caracteres no permitidos',
})

export default messages
